export const RECEIVE_INFO = "RECEIVE_INFO";
export const REQUEST_INFO = "REQUEST_INFO";
export const SET_GLOBAL_ERRORS = "SET_GLOBAL_ERRORS";
export const CLEAR_GLOBAL_ERRORS = "CLEAR_GLOBAL_ERRORS";

export const ERROR_MESSAGE = "ERROR_MESSAGE";
export const RESET_ERRORS = "RESET_ERRORS";


export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";


export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_RECEIVE = 'LOGOUT_RECEIVE'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'

export const LOAD_ORDER_REQUEST = "LOAD_ORDER_REQUEST";
export const LOAD_ORDER_SUCCESS = "LOAD_ORDER_SUCCESS";
export const LOAD_ORDER_FAILURE = "LOAD_ORDER_FAILURE";

export const LOAD_MORE_ORDER_REQUEST = "LOAD_MORE_ORDER_REQUEST";
export const LOAD_MORE_ORDER_SUCCESS = "LOAD_MORE_ORDER_SUCCESS";
export const LOAD_MORE_ORDER_FAILURE = "LOAD_MORE_ORDER_FAILURE";

export const ADD_LIKE_REQUEST = "ADD_LIKE_REQUEST";
export const ADD_LIKE_SUCCESS = "ADD_LIKE_SUCCESS";
export const ADD_LIKE_FAILURE = "ADD_LIKE_FAILURE";

export const ADD_DISLIKE_REQUEST = "ADD_DISLIKE_REQUEST";
export const ADD_DISLIKE_SUCCESS = "ADD_DISLIKE_SUCCESS";
export const ADD_DISLIKE_FAILURE = "ADD_DISLIKE_FAILURE";

export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAILED = "CREATE_ORDER_FAILED";

export const CURRENT_USER_REQUEST = "CURRENT_USER_REQUEST";
export const CURRENT_USER_SUCCESS = "CURRENT_USER_SUCCESS";
export const CURRENT_USER_FAILED = "CURRENT_USER_FAILED";

export const UPDATE_USER_DATA_REQUEST = "UPDATE_USER_DATA_REQUEST";
export const UPDATE_USER_DATA_SUCCESS = "UPDATE_USER_DATA_SUCCESS";
export const UPDATE_USER_DATA_FAILED = "UPDATE_USER_DATA_FAILED";

export const ADD_BID_USER = "ADD_BID_USER";
export const ADD_BID_MESSAGES_USERS = "ADD_BID_MESSAGES_USERS";
export const SORT_BID_USER = "SORT_BID_USER";
export const CLEAR_BID_USER = "CLEAR_BID_USER";

export const LOAD_TRANSACTION_REQUEST = "LOAD_TRANSACTION_REQUEST";
export const LOAD_TRANSACTION_SUCCESS = "LOAD_TRANSACTION_SUCCESS";
export const LOAD_TRANSACTION_FAILURE = "LOAD_TRANSACTION_FAILURE";

export const LOAD_MORE_TRANSACTION_REQUEST = "LOAD_MORE_TRANSACTION_REQUEST";
export const LOAD_MORE_TRANSACTION_SUCCESS = "LOAD_MORE_TRANSACTION_SUCCESS";
export const LOAD_MORE_TRANSACTION_FAILURE = "LOAD_MORE_TRANSACTION_FAILURE";

export const ADD_RESPONSE_REQUEST = "ADD_RESPONSE_REQUEST";
export const ADD_RESPONSE_SUCCESS = "ADD_RESPONSE_SUCCESS";
export const ADD_RESPONSE_FAILURE = "ADD_RESPONSE_FAILURE";

export const ADD_RESPONSE_BY_ID_REQUEST = "ADD_RESPONSE_BY_ID_REQUEST";
export const ADD_RESPONSE_BY_ID_SUCCESS = "ADD_RESPONSE_BY_ID_SUCCESS";

export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILED = "CREATE_USER_FAILED";

export const CREATE_USER_CLEAR_MESSAGES = "CREATE_USER_CLEAR_MESSAGES";

export const CREATE_COMPANY_REQUEST = "CREATE_COMPANY_REQUEST";
export const CREATE_COMPANY_SUCCESS = "CREATE_COMPANY_SUCCESS";
export const CREATE_COMPANY_FAILED = "CREATE_COMPANY_FAILED";

export const CREATE_USER_VERIFICATION_REQUEST = "CREATE_USER_VERIFICATION_REQUEST";
export const CREATE_USER_VERIFICATION_SUCCESS = "CREATE_USER_VERIFICATION_SUCCESS";
export const CREATE_USER_VERIFICATION_FAILED = "CREATE_USER_VERIFICATION_FAILED";

export const PHONE_CONFIRMATION_REQUEST = "PHONE_CONFIRMATION_REQUEST";
export const PHONE_CONFIRMATION_SUCCESS = "PHONE_CONFIRMATION_SUCCESS";
export const PHONE_CONFIRMATION_FAILED = "PHONE_CONFIRMATION_FAILED";

export const LOAD_EQUIPMENT_REQUEST = "LOAD_EQUIPMENT_REQUEST";
export const LOAD_EQUIPMENT_SUCCESS = "LOAD_EQUIPMENT_SUCCESS";
export const LOAD_EQUIPMENT_FAILURE = "LOAD_EQUIPMENT_FAILURE";

export const LOAD_MORE_EQUIPMENT_REQUEST = "LOAD_MORE_EQUIPMENT_REQUEST";
export const LOAD_MORE_EQUIPMENT_SUCCESS = "LOAD_MORE_EQUIPMENT_SUCCESS";
export const LOAD_MORE_EQUIPMENT_FAILURE = "LOAD_MORE_EQUIPMENT_FAILURE";

export const CREATE_EQUIPMENT_REQUEST = "CREATE_EQUIPMENT_REQUEST";
export const CREATE_EQUIPMENT_SUCCESS = "CREATE_EQUIPMENT_SUCCESS";
export const CREATE_EQUIPMENT_FAILURE = "CREATE_EQUIPMENT_FAILURE";

export const DELETE_EQUIPMENT_REQUEST = "DELETE_EQUIPMENT_REQUEST";
export const DELETE_EQUIPMENT_SUCCESS = "DELETE_EQUIPMENT_SUCCESS";
export const DELETE_EQUIPMENT_FAILURE = "DELETE_EQUIPMENT_FAILURE";

export const UPDATE_EQUIPMENT_REQUEST = "UPDATE_EQUIPMENT_REQUEST";
export const UPDATE_EQUIPMENT_SUCCESS = "UPDATE_EQUIPMENT_SUCCESS";
export const UPDATE_EQUIPMENT_FAILURE = "UPDATE_EQUIPMENT_FAILURE";

export const LOAD_COMPANIES_REQUEST = "LOAD_COMPANIES_REQUEST";
export const LOAD_COMPANIES_SUCCESS = "LOAD_COMPANIES_SUCCESS";
export const LOAD_COMPANIES_FAILURE = "LOAD_COMPANIES_FAILURE";

export const UPDATE_COMPANY_DATA_REQUEST = "UPDATE_COMPANY_DATA_REQUEST";
export const UPDATE_COMPANY_DATA_SUCCESS = "UPDATE_COMPANY_DATA_SUCCESS";
export const UPDATE_COMPANY_DATA_FAILURE = "UPDATE_COMPANY_DATA_FAILURE";

export const PUT_COMPANY_BALANCE_REQUEST = "PUT_COMPANY_BALANCE_REQUEST";
export const PUT_COMPANY_BALANCE_SUCCESS = "PUT_COMPANY_BALANCE_SUCCESS";
export const PUT_COMPANY_BALANCE_FAILURE = "PUT_COMPANY_BALANCE_FAILURE";

export const LOAD_EMPLOYEES_REQUEST = "LOAD_EMPLOYEES_REQUEST";
export const LOAD_EMPLOYEES_SUCCESS = "LOAD_EMPLOYEES_SUCCESS";
export const LOAD_EMPLOYEES_FAILURE = "LOAD_EMPLOYEES_FAILURE";

export const LOAD_COMPANY_ADMINS_REQUEST = "LOAD_COMPANY_ADMINS_REQUEST";
export const LOAD_COMPANY_ADMINS_SUCCESS = "LOAD_COMPANY_ADMINS_SUCCESS";
export const LOAD_COMPANY_ADMINS_FAILURE = "LOAD_COMPANY_ADMINS_FAILURE";

export const LOAD_COMPANY_TRANSACTIONS_REQUEST = "LOAD_COMPANY_TRANSACTIONS_REQUEST";
export const LOAD_COMPANY_TRANSACTIONS_SUCCESS = "LOAD_COMPANY_TRANSACTIONS_SUCCESS";
export const LOAD_COMPANY_TRANSACTIONS_FAILURE = "LOAD_COMPANY_TRANSACTIONS_FAILURE";

export const PAY_OUT_CONFIRM_REQUEST = "PAY_OUT_CONFIRM_REQUEST";
export const PAY_OUT_CONFIRM_SUCCESS = "PAY_OUT_CONFIRM_SUCCESS";
export const PAY_OUT_CONFIRM_FAILURE = "PAY_OUT_CONFIRM_FAILURE";

export const LOAD_PAY_OUT_LIST_REQUEST = "LOAD_PAY_OUT_LIST_REQUEST";
export const LOAD_PAY_OUT_LIST_SUCCESS = "LOAD_PAY_OUT_LIST_SUCCESS";
export const LOAD_PAY_OUT_LIST_FAILURE = "LOAD_PAY_OUT_LIST_FAILURE";

export const LOAD_ORDER_BY_ID_REQUEST = "LOAD_ORDER_BY_ID_REQUEST";
export const LOAD_ORDER_BY_ID_SUCCESS = "LOAD_ORDER_BY_ID_SUCCESS";
export const LOAD_ORDER_BY_ID_FAILURE = "LOAD_ORDER_BY_ID_FAILURE";

export const LOAD_EXECUTORS_REQUEST = "LOAD_EXECUTORS_REQUEST";
export const LOAD_EXECUTORS_SUCCESS = "LOAD_EXECUTORS_SUCCESS";
export const LOAD_EXECUTORS_FAILURE = "LOAD_EXECUTORS_FAILURE";

export const SEND_MESSAGE_REQUEST = "SEND_MESSAGE_REQUEST";
export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAILURE = "SEND_MESSAGE_FAILURE";

export const LOAD_EXECUTOR_MESSAGES_SUCCESS = "LOAD_EXECUTOR_MESSAGES_SUCCESS";
export const LOAD_EXECUTOR_PHOTOS_SUCCESS = "LOAD_EXECUTOR_PHOTOS_SUCCESS";
export const LOAD_EXECUTOR_VIDEOS_SUCCESS = "LOAD_EXECUTOR_VIDEOS_SUCCESS";

export const LOAD_EXECUTOR_MORE_MESSAGES_REQUEST = "LOAD_EXECUTOR_MORE_MESSAGES_REQUEST";
export const LOAD_EXECUTOR_MORE_MESSAGES_SUCCESS = "LOAD_EXECUTOR_MORE_MESSAGES_SUCCESS";
export const LOAD_EXECUTOR_MORE_MESSAGES_FAILURE = "LOAD_EXECUTOR_MORE_MESSAGES_FAILURE";

export const SEND_COMPLAINT_SUCCESS = "SEND_COMPLAINT_SUCCESS";
export const SEND_COMPLAINT_FAILURE = "SEND_COMPLAINT_FAILURE";

export const LOAD_STAGES_BY_ORDER_REQUEST = "LOAD_STAGES_BY_ORDER_REQUEST";
export const LOAD_STAGES_BY_ORDER_SUCCESS = "LOAD_STAGES_BY_ORDER_SUCCESS";
export const LOAD_STAGES_BY_ORDER_FAILURE = "LOAD_STAGES_BY_ORDER_FAILURE";

export const UPLOAD_WORK_SUCCESS = "UPLOAD_WORK_SUCCESS";
export const UPLOAD_VIDEO_WORK_SUCCESS = "UPLOAD_VIDEO_WORK_SUCCESS";

export const EVALUATE_WORK_SUCCESS = "EVALUATE_WORK_SUCCESS";

export const LOAD_ORDER_OBJECT_BY_ID_SUCCESS = "LOAD_ORDER_OBJECT_BY_ID_SUCCESS";

export const ACCEPT_WORK_REQUEST = "ACCEPT_WORK_REQUEST";
export const ACCEPT_WORK_SUCCESS = "ACCEPT_WORK_SUCCESS";
export const ACCEPT_WORK_FAILURE = "ACCEPT_WORK_FAILURE";

export const UPDATE_ORDER_REQUEST = "UPDATE_ORDER_REQUEST";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_FAILURE = "UPDATE_ORDER_FAILURE";

export const PUBLISH_ORDER_REQUEST = "PUBLISH_ORDER_REQUEST";
export const PUBLISH_ORDER_SUCCESS = "PUBLISH_ORDER_SUCCESS";
export const PUBLISH_ORDER_FAILURE = "PUBLISH_ORDER_FAILURE";

export const WRITE_OFF_MONEY_USER = "WRITE_OFF_MONEY_USER";
export const WRITE_OFF_MONEY_COMPANY = "WRITE_OFF_MONEY_COMPANY";
export const ADD_MONEY_USER = "ADD_MONEY_USER";

export const DOWNLOAD_WORK_REQUEST = "DOWNLOAD_WORK_REQUEST";
export const DOWNLOAD_WORK_SUCCESS = "DOWNLOAD_WORK_SUCCESS";
export const DOWNLOAD_WORK_ERROR = "DOWNLOAD_WORK_ERROR";

export const CANCEL_ORDER = "CANCEL_ORDER"

export const LOAD_NEWS_REQUEST = "LOAD_NEWS_REQUEST";
export const LOAD_NEWS_SUCCESS = "LOAD_NEWS_SUCCESS";
export const LOAD_NEWS_FAILURE = "LOAD_NEWS_FAILURE";

export const LOAD_MORE_NEWS_REQUEST = "LOAD_MORE_NEWS_REQUEST";
export const LOAD_MORE_NEWS_SUCCESS = "LOAD_MORE_NEWS_SUCCESS";
export const LOAD_MORE_NEWS_FAILURE = "LOAD_MORE_NEWS_FAILURE";

export const LOAD_ITEM_NEWS_REQUEST = "LOAD_ITEM_NEWS_REQUEST";
export const LOAD_ITEM_NEWS_SUCCESS = "LOAD_ITEM_NEWS_SUCCESS";
export const LOAD_ITEM_NEWS_FAILURE = "LOAD_ITEM_NEWS_FAILURE";

export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS";
export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS";

export const LOAD_COMPANY_INVOICES_SUCCESS = "LOAD_COMPANY_INVOICES_SUCCESS";
export const ADD_COMPANIES_INVOICE = "ADD_COMPANIES_INVOICE";
export const UPDATE_CURRENT_USER_DATA = "UPDATE_CURRENT_USER_DATA";

export const ACTIVATE_PROMOCODE_REQUEST = "ACTIVATE_PROMOCODE_REQUEST";
export const ACTIVATE_PROMOCODE_SUCCESS = "ACTIVATE_PROMOCODE_SUCCESS";
export const ACTIVATE_PROMOCODE_FAILURE = "ACTIVATE_PROMOCODE_FAILURE";

export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";

export const GET_MORE_PRODUCTS_REQUEST = "GET_MORE_PRODUCTS_REQUEST";
export const GET_MORE_PRODUCTS_SUCCESS = "GET_MORE_PRODUCTS_SUCCESS";
export const GET_MORE_PRODUCTS_FAILURE = "GET_MORE_PRODUCTS_FAILURE";

export const BUY_PACK_REQUEST = "BUY_PACK_REQUEST";
export const BUY_PACK_RECEIVE = "BUY_PACK_RECEIVE";
export const BUY_PACK_FAILURE = "BUY_PACK_FAILURE";

export const GET_CAMERAS_REQUEST = "GET_CAMERAS_REQUEST";
export const GET_CAMERAS_SUCCESS = "GET_CAMERAS_SUCCESS";
export const GET_CAMERAS_FAILURE = "GET_CAMERAS_FAILURE";

export const GET_CAMERA_BY_ID_REQUEST = "GET_CAMERA_BY_ID_REQUEST";
export const GET_CAMERA_BY_ID_SUCCESS = "GET_CAMERA_BY_ID_SUCCESS";
export const GET_CAMERA_BY_ID_FAILURE = "GET_CAMERA_BY_ID_FAILURE";

export const GET_OBJECT_TYPES_REQUEST = "GET_OBJECT_TYPES_REQUEST";
export const GET_OBJECT_TYPES_SUCCESS = "GET_OBJECT_TYPES_SUCCESS";
export const GET_OBJECT_TYPES_FAILURE = "GET_OBJECT_TYPES_FAILURE";

export const GET_METHOD_TYPES_REQUEST = "GET_METHOD_TYPES_REQUEST";
export const GET_METHOD_TYPES_SUCCESS = "GET_METHOD_TYPES_SUCCESS";
export const GET_METHOD_TYPES_FAILURE = "GET_METHOD_TYPES_FAILURE";

export const GET_MEASURES_REQUEST = "GET_MEASURES_REQUEST";
export const GET_MEASURES_SUCCESS = "GET_MEASURES_SUCCESS";
export const GET_MEASURES_FAILURE = "GET_MEASURES_FAILURE";
export const GET_MEASURE_BY_ID_SUCCESS = "GET_MEASURE_BY_ID_SUCCESS";

export const REMOVE_WORK_PHOTO_REQUEST = "REMOVE_WORK_PHOTO_REQUEST";
export const REMOVE_WORK_PHOTO_SUCCESS = "REMOVE_WORK_PHOTO_SUCCESS";
export const REMOVE_WORK_PHOTO_FAILURE = "REMOVE_WORK_PHOTO_FAILURE";

export const REMOVE_WORK_VIDEO_REQUEST = "REMOVE_WORK_VIDEO_REQUEST";
export const REMOVE_WORK_VIDEO_SUCCESS = "REMOVE_WORK_VIDEO_SUCCESS";
export const REMOVE_WORK_VIDEO_FAILURE = "REMOVE_WORK_VIDEO_FAILURE";

export const ADD_PACK_LIKE_REQUEST = "ADD_PACK_LIKE_REQUEST";
export const ADD_PACK_LIKE_SUCCESS = "ADD_PACK_LIKE_SUCCESS";
export const ADD_PACK_LIKE_FAILURE = "ADD_PACK_LIKE_FAILURE";

export const ADD_PACK_DISLIKE_REQUEST = "ADD_PACK_DISLIKE_REQUEST";
export const ADD_PACK_DISLIKE_SUCCESS = "ADD_PACK_DISLIKE_SUCCESS";
export const ADD_PACK_DISLIKE_FAILURE = "ADD_PACK_DISLIKE_FAILURE";

export const QUIT_ORDER_REQUEST = "QUIT_ORDER_REQUEST";
export const QUIT_ORDER_SUCCESS = "QUIT_ORDER_SUCCESS";
export const QUIT_ORDER_FAILURE = "QUIT_ORDER_FAILURE";

export const LOAD_LOCATIONS_REQUEST = "LOAD_LOCATIONS_REQUEST";
export const LOAD_LOCATIONS_SUCCESS = "LOAD_LOCATIONS_SUCCESS";
export const LOAD_LOCATIONS_FAILURE = "LOAD_LOCATIONS_FAILURE";

export const ADD_LOCATION_REQUEST = "ADD_LOCATION_REQUEST";
export const ADD_LOCATION_SUCCESS = "ADD_LOCATION_SUCCESS";
export const ADD_LOCATION_FAILURE = "ADD_LOCATION_FAILURE";

export const UPDATE_LOCATION_REQUEST = "UPDATE_LOCATION_REQUEST";
export const UPDATE_LOCATION_SUCCESS = "UPDATE_LOCATION_SUCCESS";
export const UPDATE_LOCATION_FAILURE = "UPDATE_LOCATION_FAILURE";

export const DELETE_LOCATION_REQUEST = "DELETE_LOCATION_REQUEST";
export const DELETE_LOCATION_SUCCESS = "DELETE_LOCATION_SUCCESS";
export const DELETE_LOCATION_FAILURE = "DELETE_LOCATION_FAILURE";

export const RESET_ALL_INFO = "RESET_ALL_INFO";


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js